import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxContentInput = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        gap: 0;
        flex-direction: column;
        justify-content: space-between;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            flex-direction: row;
            gap: 7%;
        }
`);